(() => {
  const SECTION_SELECTOR = '[data-main-blog-section]';
  const ITEMS_SELECTOR = '[data-main-blog-items]';
  const BUTTON_SELECTOR = '[data-load-more]';

  const buildSectionUrl = (nextUrl, sectionId) => {
    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    return url.toString();
  };

  const parseSection = (htmlText, currentSectionId) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlText, 'text/html');
    return doc.querySelector(`#MainBlogSection-${currentSectionId}`);
  };

  const setupLoadMore = (section) => {
    const button = section.querySelector(BUTTON_SELECTOR);
    const itemContainer = section.querySelector(ITEMS_SELECTOR);

    if (!button || !itemContainer) {
      return;
    }

    button.addEventListener('click', async () => {
      const nextUrl = button.getAttribute('data-next-url');
      const sectionId = button.getAttribute('data-section-id');

      if (!nextUrl || !sectionId || button.disabled) {
        return;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch(buildSectionUrl(nextUrl, sectionId));

        if (!response.ok) {
          throw new Error('Failed to load more blog posts');
        }

        const htmlText = await response.text();
        const nextSection = parseSection(htmlText, sectionId);

        if (!nextSection) {
          throw new Error('Could not find blog section in response');
        }

        const nextItems = nextSection.querySelector(ITEMS_SELECTOR);
        const nextButton = nextSection.querySelector(BUTTON_SELECTOR);

        if (nextItems) {
          itemContainer.insertAdjacentHTML('beforeend', nextItems.innerHTML);
        }

        if (nextButton && nextButton.getAttribute('data-next-url')) {
          button.setAttribute('data-next-url', nextButton.getAttribute('data-next-url'));
          button.disabled = false;
        } else {
          button.remove();
        }
      } catch (error) {
        button.disabled = false;
      } finally {
        button.removeAttribute('aria-busy');
      }
    });
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(SECTION_SELECTOR).forEach(setupLoadMore);
  });
})();